import { inject } from "aurelia-framework";
import { PLATFORM } from "aurelia-pal";
import { EventAggregator } from "aurelia-event-aggregator";
import { BindingSignaler } from "aurelia-templating-resources";
import { I18N } from "aurelia-i18n";
import { ConfiguresRouter, Router, RouterConfiguration } from "aurelia-router";
import { AuthorizeStep } from "../services/auth/authorize-step";
import { HttpClientService } from "../services/http-client-service";

@inject(EventAggregator, BindingSignaler, I18N, AuthorizeStep)
export class App implements ConfiguresRouter {
  constructor(
    private eventAggregator: EventAggregator,
    private bindingSignaler: BindingSignaler,
    private i18n: I18N,
    private authorizeStep: AuthorizeStep,
  ) {}

  configureRouter(config: RouterConfiguration, router: Router) {
    config.title = this.i18n.tr("mainPageTitle");
    config.options.pushState = true;
    config.options.root = HttpClientService.basePath;

    config.addPipelineStep("authorize", this.authorizeStep);

    config.map([
      {
        route: "",
        redirect: "productfinder",
        name: "default",
      },
      {
        route: "productfinder",
        name: "productfinder",
        moduleId: PLATFORM.moduleName("./productfinder/productfinder-index"),
        nav: true,
        title: "productfinder.title",
        settings: {
          auth: true,
          needsRightOneOf: ["productfinder"],
        },
      },
      {
        route: "admin",
        name: "admin",
        moduleId: PLATFORM.moduleName("./admin/admin-index"),
        nav: true,
        title: "admin.title",
        settings: {
          auth: true,
          needsRightOneOf: ["admin-read", "admin-write"],
        },
      },
      {
        route: "login",
        name: "login",
        moduleId: PLATFORM.moduleName("./auth/login"),
        title: "auth.login",
      },
      {
        route: "changePassword",
        name: "changePassword",
        moduleId: PLATFORM.moduleName("./auth/change-password"),
        title: "auth.changePassword",
        settings: {
          auth: true,
          needsRightOneOf: ["change-password"],
        },
      },
      {
        route: "passwordChanged",
        name: "passwordChanged",
        moduleId: PLATFORM.moduleName("./auth/password-changed"),
        title: "auth.changePassword",
      },
      {
        route: "noaccess",
        name: "noaccess",
        moduleId: PLATFORM.moduleName("./noaccess"),
        title: "auth.noaccess",
      },
    ]);
    config.mapUnknownRoutes(PLATFORM.moduleName("./notfound"));
    router.transformTitle = (key) => this.i18n.tr(key);

    this.eventAggregator.subscribe("auth:access-denied", () => {
      router.navigateToRoute("noaccess");
    });

    this.eventAggregator.subscribe("router:navigation:complete", () => {
      this.bindingSignaler.signal("router:navigation:complete");
    });
  }
}
